export default "__VITE_ASSET__BqYSs4Fm__"